<div class="nft-info-wrapper">
  <div class="popup-wrapper">
    <div class="popup-wrapper--header">
      <span class="popup-wrapper--title">NFT Information</span>
      <button (click)="closePopup()" class="popup--close">
        <svg viewBox="0 0 32 32" class="popup--close-icon">
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M5.35241 5.27713C5.72062 4.90764 6.31761 4.90764 6.68582 5.27713L26.7238 25.3848C27.0921 25.7543 27.0921 26.3534 26.7238 26.7229C26.3556 27.0924 25.7587 27.0924 25.3904 26.7229L5.35241 6.61517C4.98421 6.24568 4.98421 5.64662 5.35241 5.27713Z"
          ></path>
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M5.27616 26.6857C4.90795 26.3162 4.90795 25.7172 5.27616 25.3477L25.2772 5.27712C25.6454 4.90763 26.2424 4.90763 26.6106 5.27712C26.9788 5.64661 26.9788 6.24567 26.6106 6.61516L6.60956 26.6857C6.24135 27.0552 5.64437 27.0552 5.27616 26.6857Z"
          ></path>
        </svg>
      </button>
    </div>
    <div class="popup-wrapper--body">
      <div class="popup-wrapper--body-in">
        <app-preview [flowInfo]="nftInfo"></app-preview>
      </div>
    </div>
    <div class="popup-wrapper--footer">
      <ng-container *ngIf="canEdit">
        <button class="w-btn w-btn--primary" (click)="editHandler()">
          Edit
        </button>
      </ng-container>
      <ng-container *ngIf="canReport">
        <a class="w-link" (click)="reportHandler()"> Report </a>
      </ng-container>
    </div>
  </div>
</div>
